import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useAppColors } from '../../hooks/useAppColors';
import { useTranslation } from 'react-i18next';

interface ClassStatusBadgeProps {
  isClosed?: boolean;
  isPublicHoliday?: boolean;
  closedReason?: string | null | undefined;
  isTimeChanged?: boolean;
  compact?: boolean;
}

export function ClassStatusBadge({
  isClosed,
  isPublicHoliday,
  closedReason,
  isTimeChanged,
  compact = false,
}: ClassStatusBadgeProps) {
  const { t } = useTranslation();
  const colors = useAppColors();

  // Nothing to show
  if (!isClosed && !isTimeChanged) return null;

  // Determine icon and text
  let iconName = 'calendar-remove';
  let badgeText = '';

  if (isClosed) {
    iconName = 'calendar-remove';
    if (isPublicHoliday) {
      badgeText = `${t('classes.closedBadge')}: ${t('classes.publicHolidayBadge')}`;
    } else if (closedReason) {
      badgeText = `${t('classes.closedBadge')}: ${closedReason}`;
    } else {
      badgeText = t('classes.closedBadge');
    }
  } else if (isTimeChanged) {
    iconName = 'clock-alert';
    badgeText = t('classes.timeChanged');
  }

  return (
    <View
      style={[
        styles.badge,
        {
          backgroundColor: colors.card,
          borderColor: colors.warning,
          marginTop: compact ? 4 : 0,
          alignSelf: compact ? 'flex-start' : 'auto',
        },
      ]}
    >
      <Icon name={iconName} size={10} color={colors.warning} style={styles.badgeIcon} />
      <Text style={[styles.badgeText, { color: colors.warning }]}>{badgeText}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    borderWidth: 1,
  },
  badgeIcon: {
    marginRight: 2,
  },
  badgeText: {
    fontSize: 11,
    fontWeight: '600',
  },
});
